module.exports = __webpack_public_path__ + "img/pr-1.6568563f.png";